<template>
  <div>
    <el-dialog v-if="dialogFormVisible" v-el-drag-dialog title="分享记录" :append-to-body="true" :visible.sync="dialogFormVisible" width="1000px" :close-on-click-modal="false">
      <el-table
        :data="shareList"
        :show-header="true"
        border
        style="width: 100%;margin-top:10px"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="45"
          align="center"
        />
        <el-table-column
          show-overflow-tooltip
          label="序号"
          type="index"
          align="center"
          width="45"
        />
        <el-table-column
          show-overflow-tooltip
          prop="shareScope"
          label="分享范围"
          align="center"
        />
        <el-table-column
          show-overflow-tooltip
          prop="period"
          label="有效期"
          width="150"
          align="center"
        />
        <el-table-column
          show-overflow-tooltip
          :formatter="columnFormatter"
          prop="shareDate"
          label="分享时间"
          align="center"
          width="150"
        />
        <el-table-column
          show-overflow-tooltip
          label="操作"
          align="center"
          width="70"
        >
          <template slot-scope="scope">
            <el-link @click="undo(scope.row)">撤销</el-link>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button :icon="'el-icon-close'" @click="dialogFormVisible=false">关 闭</el-button>
        <el-button :icon="'el-icon-check'" type="primary" @click="allUndo">批量撤销</el-button>
      </span>
    </el-dialog></div>
</template>

<script>
const moment = require('moment')
export default {
    // import引入的组件需要注入到对象中才能使用
    components: {

    },
    data() {
        return {
            dialogFormVisible: false,
            activeName: 0,
            row: {},
            shareList: [],
            operationList: [], // 可查阅选择的list
            operationList1: []// 已过期选择的list
        }
    },
    computed: {

    },
    // 监控data中的数据变化
    watch: {
        dialogFormVisible(val) {
            if (!val) {
                this.activeName = 0
                this.operationList = []
                this.operationList1 = []
            }
        }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.$bus.$on('openCanShareRecord', (row, list) => {
            this.row = row
            this.shareList = list
            this.dialogFormVisible = true
        })
    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() {}, // 生命周期 - 创建之前
    beforeMount() {}, // 生命周期 - 挂载之前
    beforeUpdate() {}, // 生命周期 - 更新之前
    updated() {}, // 生命周期 - 更新之后
    beforeDestroy() {
        // 分享记录
        this.$bus.$off('openCanShareRecord', (row, list) => {
            this.row = row
            this.shareList = list
            this.dialogFormVisible = true
        })
    }, // 生命周期 - 销毁之前
    destroyed() {}, // 生命周期 - 销毁完成
    activated() {},
    // 方法集合
    methods: {
        // 分享按钮操作
        shareClick(val) {
            if (!val) {
                // 可查阅撤销分享
                if (this.operationList.length < 1) {
                    this.$alert('请选择要撤销分享的记录!', '提示', {
                        type: 'warning'
                    })
                    return
                }
            } else {
                // 已过期再次分享
                if (this.operationList1.length < 1) {
                    this.$alert('请选择要再次分享的记录!', '提示', {
                        type: 'warning'
                    })
                    return
                }
                this.operationList1
            }
        },
        // 切换tab
        handleClick() {
            this.getlistdata()
        },
        // 获取列表数据
        async getlistdata(row) {
            const { staffList, personId, orgCode } = { ...this.loginUser }
            this.row = row
            const params = {
                pageNum: 1,
                pageSize: 100000,
                urlsearch: `fileId:${row.fileId};status:3` // status:1分享文件;status:2全部分享记录;status:3有效期内的分享记录
            }
            const res = await this.$app.listdata('disk/vwsharefile/listdata', params)
            if (res.code === 'success') {
                this.shareList = res.body.pageInfo.list
                this.dialogFormVisible = true
            } else {
                this.$message.error(res.message)
            }
        },
        handleSelectionChange(list) {
            this.operationList = list
        },
        handleSelectionChange1(list) {
            this.operationList1 = list
        },
        // 格式化时间
        columnFormatter(row, column, cellValue, index) {
            if (cellValue) {
                return moment(cellValue).format('YYYY-MM-DD HH:mm')
            } else {
                return ''
            }
        },
        // 批量撤销
        allUndo() {
            var _this = this
            if (this.operationList.length < 1) {
                this.$alert('请选择要撤销的分享记录!', '操作提示', { type: 'warning' })
                return
            }
            this.$confirm('确认要撤销选中的分享记录吗？', '确认操作', { type: 'warning' })
                .then(function() {
                    let ids = ''
                    for (let index = 0; index < _this.operationList.length; index++) {
                        const element = _this.operationList[index]
                        if (ids !== '') {
                            ids += ',' + element.shareId
                        } else {
                            ids += element.shareId
                        }
                    }
                    const params = {
                        ids: ids
                    }
                    _this.$http({
                        method: 'POST',
                        contentType: 'application/x-www-form-urlencoded',
                        params: params,
                        url: '/disk/vwsharefile/updateUndo'
                    }).then(res => {
                        if (res.code === 'success') {
                            // 刷新列表
                            _this.$bus.$emit('refreshListData')
                            // 刷新当前页面
                            _this.getlistdata(_this.row)
                            _this.$message.success(res.message)
                        } else {
                            _this.$message.error(res.message)
                        }
                    })
                })
                .catch(err => { if (err !== 'cancel') { console.error(err) } })
        },
        // 操作列撤销
        undo(row) {
            var _this = this
            this.$confirm('确认要撤销该分享记录吗？', '确认操作', { type: 'warning' })
                .then(function() {
                    const params = {
                        ids: row.shareId
                    }
                    _this.$http({
                        method: 'POST',
                        contentType: 'application/x-www-form-urlencoded',
                        params: params,
                        url: '/disk/vwsharefile/updateUndo'
                    }).then(res => {
                        if (res.code === 'success') {
                            // 刷新列表
                            _this.$bus.$emit('refreshListData')
                            // 刷新当前页面
                            _this.getlistdata(_this.row)
                            _this.$message.success(res.message)
                        } else {
                            _this.$message.error(res.message)
                        }
                    })
                })
                .catch(err => { if (err !== 'cancel') { console.error(err) } })
        }
    } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
// @import url(); 引入公共css类
.rowbg{
    height:35px;
    justify-content: space-between;
    align-items: center;
}
</style>
